import React from "react";
import "./OceShaIdeaSection.css";

interface OceShaIdeaSectionProps {
  imageSrc?: string;
  onStartFree?: () => void;
}

const OceShaIdeaSection: React.FC<OceShaIdeaSectionProps> = ({
  imageSrc = "/idea-section.png",
  onStartFree,
}) => {
  return (
    <section className="ocesha-idea-section">
      <div className="ocesha-idea-section__inner">

        {/* Rounded card matching the previous section */}
        <div className="ocesha-idea-section__card">

          {/* Original image - NOT stretched */}
          <div className="ocesha-idea-section__image-wrapper">
            <img
              className="ocesha-idea-section__image"
              src={imageSrc}
              alt="Start with an idea or your existing content and let OceSha create a complete course"
            />
          </div>

        </div>

        {/* Start Free button */}
        <div className="ocesha-idea-section__action">
          <button
            type="button"
            className="ocesha-idea-section__button"
            onClick={onStartFree}
          >
            Start Free
          </button>
        </div>

      </div>
    </section>
  );
};

export default OceShaIdeaSection;